<template>
  <user-list :is-modal="false">
    <h2 slot="header">{{ getTranslations.home_users_search_user_your_list }}</h2>
    <template slot="content">
      <virtual-list :data-key="'username'"
                    :items="getProps()"
                    :wrapperType="'favorite_user'"
                    :remain="5"
                    :estimated="150"/>
      <empty-state v-if="!getFavoriteUsers.filter(user => !user.blocked).length" :text="getTranslations.home_users_empty_state_text"/>
    </template>
  </user-list>
</template>

<script>
import { mapGetters } from 'vuex';
import UserList from '@/components/home/shared/GenericList';
import EmptyState from '@/components/home/users/EmptyState';
import VirtualList from '@/components/home/shared/VirtualScrollList';

export default {
  name: 'favorite-user-list',
  components: {
    UserList,
    EmptyState,
    VirtualList,
  },
  methods: {
    getProps() {
      return this.getFavoriteUsers
        .filter(user => !user.blocked)
        .map(user => ({ ...user, isFavorite: true }));
    },
  },
  computed: {
    ...mapGetters('users', [
      'getFavoriteUsers',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/users/FavoriteUserList.vue